import { transformRoutes } from '@shared/utils';

const routeDefs = {
  root: {
    path: '/',
  },
  marketInsight: {
    path: '/marketinsight',
    sub: {
      assortments: {
        path: '/assortments',
        sub: {
          assortment: {
            path: '/:assortmentId',
          },
        },
      },
      competitors: {
        path: '/competitors',
        sub: {
          edit: {
            path: '/edit',
          },
        },
      },
    },
  },
  items: {
    path: '/items',
    sub: {
      item: {
        path: '/:itemNumber',
      },
    },
  },
  calculus: {
    path: '/calculus',
    sub: {
      calculusArea: {
        path: '/:calculusArea',
      },
    },
  },
  discounts: {
    path: '/discounts',
    sub: {
      discountArea: {
        path: '/:discountArea',
      },
    },
  },
  assortment: {
    path: '/assortment',
  },

  superuser: {
    path: '/superuser',
    sub: {
      features: {
        path: '/features',
      },
      permissions: {
        path: '/permissions',
      },
    },
  },
  users: {
    path: '/users',
  },
  administration: {
    path: '/administration',
    sub: {
      suppliers: {
        path: '/suppliers',
      },
      rounding: {
        path: '/rounding',
      },
      assortments: {
        path: '/assortments',
      },
      fixedPrice: {
        path: '/fixedPrice',
      },
    },
  },
  export: {
    path: '/export',
  },
  insightReport: {
    path: '/insightReport',
  },
  approval: {
    path: '/approval',
    sub: {
      calculus: {
        path: '/calculus',
      },
    },
  },
  priceControl: {
    path: '/priceControl',
    sub: {
      supplier: {
        path: '/:supplierNumber',
      },
    },
  },
  dashboard: {
    path: '/dashboard',
  },
  memberConfig: {
    path: '/memberConfig',
  },
  campaigns: {
    path: '/campaigns',
    sub: {
      campaignDetails: {
        path: '/:campaignId',
      },
      campaignType: {
        path: '/:campaignType',
        sub: {
          campaignDetails: {
            path: '/:campaignId',
          },
        },
      },
    },
  },
  centralAssortments: {
    path: '/centralAssortments',
  },
} as const;

export const mgPrisRoutes = transformRoutes(routeDefs, '');
